// File: noviopus-ats-client/src/features/Account/selectors.ts
import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './accountSlice';

const selectAccountDomain = (state: any) => state.accountFeature || initialState;

export const selectAccountData = createSelector(
  [selectAccountDomain],
  (state) => state.data
);

export const selectAccountIsMultiOrg = createSelector(
  [selectAccountData],
  (account) => !!account?.isMultiOrg
);

export const selectAccountLoading = createSelector(
  [selectAccountDomain],
  (state) => state.loading
);

export const selectAccountSaveStatus = createSelector(
  [selectAccountDomain],
  (state) => state.saveStatus
);

export const selectAccountError = createSelector(
  [selectAccountDomain],
  (state) => state.error
);

// FIX: Added missing selector for TeamMemberDialog
export const selectAccountUsers = createSelector(
  [selectAccountData],
  (account) => account?.users || []
);